<template>
  <result-options-wrapper
    @click-close="$emit('click-close')"
    @click-edit-quote="$emit('click-edit-quote')"
    @click-details="$emit('click-details', $event)"
  >
    <template #filters>
      <!-- FILTERS -->
      <v-expansion-panels
        v-model="panelsShown"
        multiple
        accordion
        flat
      >
        <!-- COVER TYPES -->
        <v-expansion-panel>
          <v-expansion-panel-header><strong>Cover Level</strong></v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <a
              href="#"
              class="caption"
              @click.prevent="showCoverTypeDetails"
            >
              What's the difference in cover types?
            </a>
            <v-select
              v-model="coverLevel"
              :items="options.coverLevelOptions"
              outlined
              dense
              hide-details
              attach
              class="mt-2"
            />
          </v-expansion-panel-content>
          <div
            v-show="!panelsShown.includes(0)"
            class="v-expansion-panel-content__wrap"
          >
            <p class="caption mb-0 text-capitalize">
              {{ coverLevel }}
            </p>
          </div>
          <v-divider />
        </v-expansion-panel>

        <!-- OPTIONAL EXTRAS -->
        <v-expansion-panel>
          <v-expansion-panel-header><strong>Optional Extras</strong></v-expansion-panel-header>
          <v-expansion-panel-content v-scroll-to-viewport>
            <p class="body-2 mb-0">
              Additional extras to enhance your policy.
            </p>
            <a
              href="#"
              class="caption"
              @click.prevent="showOptionalExtras"
            >
              Learn more about optional extras
            </a>
            <v-checkbox
              v-for="(extra, index) in options.optionalExtrasOptions"
              :key="`extra-${index}`"
              v-model="optionalExtrasModel"
              :label="extra.label"
              :value="extra.value"
              hide-details
              dense
              class="mt-2 text-capitalize optional-extras-checkbox"
            />
          </v-expansion-panel-content>
          <div
            v-show="!panelsShown.includes(1)"
            class="v-expansion-panel-content__wrap"
          >
            <p
              v-if="optionalExtrasModel && optionalExtrasModel.length"
              class="caption mb-0"
            >
              <span
                v-for="(extratitle, key) in optionalExtrasModel"
                :key="`extra-title-${key}`"
              >
                {{ getOptionalExtrasTitle(extratitle) }}<span
                  v-if="key !== optionalExtrasModel.length - 1"
                >, </span>

              </span>
            </p>
            <p
              v-else
              class="caption mb-0"
            >
              Any
            </p>
          </div>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </result-options-wrapper>
</template>

<script>
import ResultOptionsWrapper from '@/components/results/ResultOptionsWrapper';

export default {
  name: 'results-options',
  components: { ResultOptionsWrapper },
  inject: ['constants'],
  props: {
    formData: {
      type: Object,
      required: false,
      default: () => {},
    },
    options: {
      type: Object,
      required: true,
    },
    detailsDescription: {
      type: Object,
      required: false,
      default: () => {},
    },
    selectedFilters: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    panelsShown: [0, 1, 2, 3],
    selectedOptionalExtras: [],
  }),
  computed: {
    coverLevel: {
      get () {
        return this.selectedFilters.coverLevel || this.formData.cover.typeOfCover;
      },
      set (value) {
        return this.$emit('change-filter', { filter: 'coverLevel', value });
      },
    },
    optionalExtrasModel: {
      get () {
        return this.selectedFilters.optionalExtras;
      },
      set (value) {
        this.selectedOptionalExtras = value;
        return this.$emit('change-filter', { filter: 'optionalExtras', value: this.selectedOptionalExtras });
      },
    },
  },
  methods: {
    showCoverTypeDetails () {
      this.$emit('click-details', ['details-description', 'coverType']);
    },
    showOptionalExtras () {
      this.$emit('click-details', ['details-description', 'optionalExtras']);
    },
    getOptionalExtrasTitle (key) {
      const optionalExtraTitle = this.detailsDescription.optionalExtras?.content.find((el) => el.slug === key);
      if (optionalExtraTitle) {
        return optionalExtraTitle.name;
      }
      return key;
    },
  },
};
</script>

<style scoped lang="scss" src='@/assets/scss/results/results-options.scss'></style>
